import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 50 30"
    {...props}
  >
    <rect
      width={30}
      height={30}
      transform="translate(10)"
      fill="white"
    />
    <rect
      x={25}
      width={15}
      height={15}
      fill="#0298DD"
      fillOpacity={0.2}
    />
    <circle
      cx={25}
      cy={6}
      r={1}
      fill="#0298DD"
    />
    <circle
      cx={32}
      cy={4}
      r={1}
      fill="#0298DD"
    />
    <circle
      cx={37}
      cy={10}
      r={1}
      fill="#0298DD"
    />
    <rect
      x={10}
      y={15}
      width={15}
      height={15}
      fill="#EFEFFB"
    />
    <circle
      cx={12}
      cy={26}
      r={1}
      fill="#0298DD"
    />
    <circle
      cx={19}
      cy={19}
      r={1}
      fill="#0298DD"
    />
  </svg>
);
const SvgScatterChart = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgScatterChart;
